package ru.dinarastepina.fabvocab.contracts

import kotlinx.serialization.Serializable

@Serializable
data class WordStatsDto(
    val wordId: String,
    val attempts: Int,
    val correct: Int,
    val accuracyPercent: Int,
)
